var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyCompetencies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3200,
    height: 1800,
    viewBox: "0 0 3200 1800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 300H1875.28V314H1705.39C1702.41 314 1700 310.866 1700 307C1700 303.134 1702.41 300 1705.39 300Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 300H1894.11V314H2069.39V300Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 300H2088.34V314H2266.31V300Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 300H2285.2V314H2460.48V300Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 300H2649.2C2652.18 300 2654.59 303.134 2654.59 307C2654.59 310.866 2652.18 314 2649.2 314H2479.31V300Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 434H1875.28V448H1705.39C1702.41 448 1700 444.866 1700 441C1700 437.134 1702.41 434 1705.39 434Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 434H1894.11V448H2069.39V434Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 434H2088.34V448H2266.31V434Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 434H2285.2V448H2460.48V434Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 434H2649.2C2652.18 434 2654.59 437.134 2654.59 441C2654.59 444.866 2652.18 448 2649.2 448H2479.31V434Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 568H1875.28V582H1705.39C1702.41 582 1700 578.866 1700 575C1700 571.134 1702.41 568 1705.39 568Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 568H1894.11V582H2069.39V568Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 568H2088.34V582H2266.31V568Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 568H2285.2V582H2460.48V568Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 568H2649.2C2652.18 568 2654.59 571.134 2654.59 575C2654.59 578.866 2652.18 582 2649.2 582H2479.31V568Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 702H1875.28V716H1705.39C1702.41 716 1700 712.866 1700 709C1700 705.134 1702.41 702 1705.39 702Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 702H1894.11V716H2069.39V702Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 702H2088.34V716H2266.31V702Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 702H2285.2V716H2460.48V702Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 702H2649.2C2652.18 702 2654.59 705.134 2654.59 709C2654.59 712.866 2652.18 716 2649.2 716H2479.31V702Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 836H1875.28V850H1705.39C1702.41 850 1700 846.866 1700 843C1700 839.134 1702.41 836 1705.39 836Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 836H1894.11V850H2069.39V836Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 836H2088.34V850H2266.31V836Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 836H2285.2V850H2460.48V836Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 836H2649.2C2652.18 836 2654.59 839.134 2654.59 843C2654.59 846.866 2652.18 850 2649.2 850H2479.31V836Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 970H1875.28V984H1705.39C1702.41 984 1700 980.866 1700 977C1700 973.134 1702.41 970 1705.39 970Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 970H1894.11V984H2069.39V970Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 970H2088.34V984H2266.31V970Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 970H2285.2V984H2460.48V970Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 970H2649.2C2652.18 970 2654.59 973.134 2654.59 977C2654.59 980.866 2652.18 984 2649.2 984H2479.31V970Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 1506.01H1875.28V1520.01H1705.39C1702.41 1520.01 1700 1516.87 1700 1513.01C1700 1509.14 1702.41 1506.01 1705.39 1506.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 1506.01H1894.11V1520.01H2069.39V1506.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1506.01H2088.34V1520.01H2266.31V1506.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 1506.01H2285.2V1520.01H2460.48V1506.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 1506.01H2649.2C2652.18 1506.01 2654.59 1509.14 2654.59 1513.01C2654.59 1516.87 2652.18 1520.01 2649.2 1520.01H2479.31V1506.01Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 1104H1875.28V1118H1705.39C1702.41 1118 1700 1114.87 1700 1111C1700 1107.14 1702.41 1104 1705.39 1104Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 1104H1894.11V1118H2069.39V1104Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1104H2088.34V1118H2266.31V1104Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 1104H2285.2V1118H2460.48V1104Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 1104H2649.2C2652.18 1104 2654.59 1107.13 2654.59 1111C2654.59 1114.87 2652.18 1118 2649.2 1118H2479.31V1104Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 1238.01H1875.28V1252.01H1705.39C1702.41 1252.01 1700 1248.87 1700 1245.01C1700 1241.14 1702.41 1238.01 1705.39 1238.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 1238H1894.11V1252H2069.39V1238Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1238H2088.34V1252H2266.31V1238Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 1238H2285.2V1252H2460.48V1238Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 1238H2649.2C2652.18 1238 2654.59 1241.14 2654.59 1245C2654.59 1248.87 2652.18 1252 2649.2 1252H2479.31V1238Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1705.39 1372.01H1875.28V1386.01H1705.39C1702.41 1386.01 1700 1382.87 1700 1379.01C1700 1375.14 1702.41 1372.01 1705.39 1372.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2069.39 1372.01H1894.11V1386.01H2069.39V1372.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2266.31 1372.01H2088.34V1386.01H2266.31V1372.01Z",
    fill: "#2D72FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2460.48 1372.01H2285.2V1386.01H2460.48V1372.01Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2479.31 1372.01H2649.2C2652.18 1372.01 2654.59 1375.14 2654.59 1379.01C2654.59 1382.87 2652.18 1386.01 2649.2 1386.01H2479.31V1372.01Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1028.47 577.015C1078.28 577.015 1096.39 517.381 1124.69 484.655C1144.94 461.241 1179.5 468.223 1189.73 435.443C1215.45 353.015 1146.61 295 1056.8 295C966.988 295 906.433 345.881 893.358 422.368C880.283 498.855 938.659 577.015 1028.47 577.015Z",
    fill: "#4A312C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1164.2 413.26C1189.46 460.335 1186.46 579.745 1153.81 588.159C1140.8 591.514 1113.07 583.295 1084.85 566.285L1102.56 691.611H997.959L1033.97 523.768C1013.88 500.195 1000.29 471.307 1002.56 438.937C1009.11 345.667 1138.95 366.185 1164.2 413.26Z",
    fill: "#915B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1170.48 413.523C1150.47 417.279 1110.18 436.377 1078.06 463.772C1074.26 461.76 1069.91 460.617 1065.28 460.617C1050.46 460.617 1038.45 472.325 1038.45 486.767C1038.45 492.662 1040.45 498.101 1043.83 502.475C1037.47 512.955 1033.13 523.965 1031.71 535.284C1009.67 535.284 929.243 451.901 1009.36 373.45C1089.48 295 1205.27 406.992 1170.48 413.523Z",
    fill: "#4A312C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M963.092 1053.35L1122.74 1603.49L1197.83 2016.55H1273.2L1197.97 1053.35H963.092Z",
    fill: "#915B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M963.092 1053.35L1122.74 1603.49L1197.83 2016.55H1273.2L1197.97 1053.35H963.092Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M891.344 1053.35C902.484 1339.15 898.09 1495.03 895.597 1521C893.104 1546.96 878.949 1720.86 782.498 2025.27H860.889C988.623 1733.24 1033.21 1559.34 1047.86 1521C1062.51 1482.65 1105.78 1326.77 1168.95 1053.35H891.344Z",
    fill: "#915B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M959.665 1053.35C1001.19 1242.66 1073.02 1544.84 1175.14 1959.89H1285.38C1293.52 1533.88 1258.88 1253.49 1198.9 1053.35H959.665Z",
    fill: "#4098CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M890.786 1053.35C901.696 1339.15 873.422 1620.71 785.84 1964.34H903.456C1031.42 1676.68 1123.14 1396.5 1185.83 1053.35H890.786Z",
    fill: "#9FCBE6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M798.817 1001.14L889.895 1001.5C833.658 1183.04 803.299 1279.36 798.817 1290.47C788.732 1315.47 810.073 1353.53 819.199 1373.99C789.475 1387.29 792.642 1338.03 755.146 1355.47C720.921 1371.4 694.886 1400.25 655.345 1375.85C650.483 1372.85 645.156 1361.55 658.027 1352.73C690.095 1330.74 736.306 1292.26 742.55 1279.59C751.065 1262.31 769.821 1169.5 798.817 1001.14ZM1332.6 997.617L1471.62 1099.71C1509.33 1109.88 1540.83 1122.54 1566.13 1137.68C1572.11 1143.13 1579.33 1154.15 1554.54 1152.25C1529.76 1150.34 1503.61 1149.45 1500.19 1157.91C1496.77 1166.36 1511.76 1176.47 1504.85 1187.87C1500.24 1195.48 1478.47 1176.41 1439.54 1130.68L1301.87 1073.59L1332.6 997.617Z",
    fill: "#915B3C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1057.65 618.967L1095.33 612.502C1235.16 733.296 1292.6 965.355 1464 1088.29L1422.74 1139.42C1125.4 1102.61 1051.7 819.55 1057.65 618.967Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M893.358 1092.58C1044.47 1092.58 1155.62 1092.58 1226.82 1092.58C1242.06 1092.58 1239.19 1070.58 1236.99 1059.47C1211.56 931.337 1112.33 793.211 1112.33 610.811L1016.14 595.728C936.582 723.682 909.07 881.22 893.358 1092.58Z",
    fill: "#C7D1D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1008.9 595.727C1012.15 595.727 1015.12 595.93 1017.83 596.337L1047.96 598.058C1134.35 890.854 1158.18 1086.2 1119.44 1184.1L856.971 1184.11C841.422 1220.37 826.542 1250.88 812.332 1275.63H740.816C734.085 1058 785.827 873.294 896.04 721.498C882.07 717.486 871.006 708.12 862.85 693.403C827.694 629.967 840.39 595.04 877.961 583.56C915.532 572.079 949.038 595.727 1008.9 595.727Z",
    fill: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M954.375 1184.1L856.973 1184.11C875.112 1141.81 894.163 1091.69 914.126 1033.73C922.381 1102.79 935.797 1152.92 954.375 1184.1Z",
    fill: "black",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3200,
    height: 1800,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyCompetencies);
export default __webpack_public_path__ + "static/media/key-competencies.1e3946c0c49fb2081ca395a18ee0c870.svg";
export { ForwardRef as ReactComponent };